import type React from 'react';

import screen from '../ChatScreen.module.scss';
import { ChatAvatar } from './ChatAvatar';

/**
 * prod1: карточка диалога в списке чатов (общая для «Мои чаты», «Чаты и отклики» и списка
 * репетиторов по заявке). Аватар с точкой «в сети», серая рамка, имя/предмет/последнее сообщение
 * обрезаются многоточием внутри карточки, выбранный диалог подсвечен.
 */
export interface ChatListCardProps {
  name: string;
  fullName: string;
  avatar?: string;
  online: boolean;
  subject?: string | null;
  meta?: string | null;
  preview: string;
  time?: string | null;
  unread?: number;
  blocked?: boolean;
  selected: boolean;
  accent: 'student' | 'tutor';
  onSelect: () => void;
}

export const ChatListCard: React.FC<ChatListCardProps> = ({
  name,
  fullName,
  avatar,
  online,
  subject,
  meta,
  preview,
  time,
  unread = 0,
  blocked = false,
  selected,
  accent,
  onSelect,
}) => (
  <div
    className={`${screen.lcCard} ${selected ? (accent === 'tutor' ? screen.lcCardOnTutor : screen.lcCardOnStudent) : ''}`}
    onClick={onSelect}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onSelect();
      }
    }}
    role='button'
    tabIndex={0}
    aria-current={selected ? 'true' : undefined}
    aria-label={`${fullName}${online ? ', в сети' : ''}${unread > 0 ? `, непрочитанных: ${unread}` : ''}`}
  >
    <span className={screen.lcAvatarWrap}>
      <ChatAvatar src={avatar} alt='' className={screen.lcAvatar} />
      {online ? <span className={screen.lcOnline} title='В сети' /> : null}
    </span>
    <span className={screen.lcBody}>
      <span className={screen.lcTop}>
        <span className={screen.lcName} title={fullName}>
          {name}
        </span>
        {time ? <span className={screen.lcTime}>{time}</span> : null}
      </span>
      {subject ? (
        <span className={screen.lcSubject} title={subject}>
          {subject}
          {meta ? <span className={screen.lcMeta}>{meta}</span> : null}
        </span>
      ) : null}
      <span className={screen.lcBottom}>
        <span className={screen.lcPreview} title={preview}>
          {preview}
        </span>
        {blocked ? (
          <span className={screen.lcBlocked}>блок</span>
        ) : unread > 0 ? (
          <span className={screen.lcUnread}>{unread > 9 ? '9+' : unread}</span>
        ) : null}
      </span>
    </span>
  </div>
);
